<template>
  <div class="mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>
        <div class="mb-5">       
          <h1 class="title my-title">
            <span>Sales Monitor</span>
          </h1>&nbsp;
          <div class="select">
            <select v-model="selectedDate">
              <option v-for="(o, i) in dates" :key="'date-option-' +i">{{o}}</option>
            </select>
          </div>&nbsp;
          <span class="is-size-7 has-text-grey">
            <span v-if="selectedDate == 'Now'">Sales data are till yesterday, inventory and landed cost are the latest.</span>
            <span v-else>Sales data are till {{ selectedDate }}, inventory and landed cost are of {{ selectedDate }}.</span>
          </span>
        </div>

        <div class="tabs is-toggle">
          <ul style="display:contents">
            <li :class="{'is-active': country == 'US'}">
              <a @click="country = 'US'">
                <span>US</span>
              </a>
            </li>
            <li :class="{'is-active': country == 'Canada'}">
              <a @click="country = 'Canada'">
                <span>Canada</span>
              </a>
            </li>
          </ul>&nbsp;&nbsp;&nbsp;&nbsp;
          <ul>
            <li :class="{'is-active': showMode == 'items'}">
              <a @click="showMode = 'items'">
                <span>Items</span>
              </a>
            </li>
            <li :class="{'is-active': showMode == 'classes'}">
              <a @click="showMode = 'classes'">
                <span>Classes</span>
              </a>
            </li>
          </ul>
        </div>

        <div v-if="showMode == 'items'">
          <label class="checkbox">
            <input type="checkbox" v-model="showHidden" />
            Show hidden
          </label>

          <div class="mt-3">
            <div v-if="waiting">
              <span class="icon is-medium is-size-4">
                <i class="fas fa-spinner fa-pulse"></i>
              </span>
            </div>
            <div v-else>
              <div class="columns mt-4">
                <div class="column field mb-0 pb-0">
                  <p class="control has-icons-left">
                    <span class="select is-multiple">
                      <select multiple size="5" v-model="filter">
                        <option v-for="(c, i) in classOptions"  :key="'product-class-option' + i">
                          {{c}}
                        </option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-filter"></i>
                    </span>
                  </p>
                </div>
                <div class="column field  mb-0 pb-0">
                  <p class="control has-icons-left">
                    <input class="input" type="text" placeholder="Search" v-model="search">
                    <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                  </p>
                </div>
              </div>

              <div class="table-container">
                <table class="table is-fullwidth is-hoverable my-table">
                  <thead>
                    <th class="is-clickable" @click="changeSortOption('itemId')">
                      <span>Item id</span>
                      <span class="icon" v-if="sortOption.field == 'itemId'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="is-clickable" @click="changeSortOption('className')">
                      <span>Class</span>
                      <span class="icon" v-if="sortOption.field == 'className'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="is-clickable" @click="changeSortOption('itemSku')">
                      <span>SKU / Platform</span>
                      <span class="icon" v-if="sortOption.field == 'itemSku'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.inventory.all')">
                      <span>Inventory</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.inventory.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span><br/>
                      <span class="is-size-7 has-text-grey">Landed cost</span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.quantity')">
                      <span>One week sales</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.quantity'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.days')">
                      <span>One week days</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.days'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.speed')">
                      <span>One week speed</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.speed'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.quantity')">
                      <span>Two weeks sales</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.quantity'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.days')">
                      <span>Two week days</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.days'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.speed')">
                      <span>Two weeks speed</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.speed'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.4w.all.quantity')">
                      <span>One month sales</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.4w.all.quantity'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.yearMax.all')">
                      <span>One year max speed</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.yearMax.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.speedIncrease.all')">
                      <span>Speed increase rate (%)</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.speedIncrease.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.potential.all')">
                      <span>Sales Potential (%)</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.potential.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.coverage.all')">
                      <span>Coverage in weeks</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.coverage.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                    <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.remaining.all')">
                      <span>OOS in days</span>
                      <span class="icon" v-if="sortOption.field == countryPrefix + '.remaining.all'">
                        <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                      </span>
                    </th>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in showingItems" :key="'product-' + i">
                      <td :class="{'has-text-weight-bold': p.itemId, 'hover-trigger': !showHidden}">
                        <router-link :to="'/sales-summary/' + p.itemId">{{p.itemId}}</router-link>
                        <button v-if="p.itemId" class="button is-small is-white" :class="{'hover-target': !showHidden}" @click="toggleHidden(p.id)">
                          <span class="icon is-small">
                            <i class="fas" :class="{'fa-eye-slash': p.hidden, 'fa-eye': !p.hidden}"></i>
                          </span>
                        </button>
                      </td>
                      <td :class="{'has-text-weight-bold': p.itemId, 'has-text-right': !p.itemId}">
                        <span>{{p.className}}</span>
                      </td>
                      <td :class="{'has-text-weight-bold': p.itemId, 'has-text-right': !p.itemId}">
                        <span>{{p.name}}</span>
                        <span v-if="p.itemId">
                          <button class="button is-small is-white" @click="toggleOpened(p.itemId)">
                            <span class="icon is-small">
                              <i class="fas" :class="{'fa-angle-up': openedMap[p.itemId], 'fa-angle-down': !openedMap[p.itemId]}"></i>
                            </span>
                          </button>
                        </span>
                      </td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">
                        <span>{{ p.inventory }}</span>
                        <span v-if="p.landedCost"><br/>
                          <span class="is-size-7 has-text-grey">{{ p.landedCost }}</span>
                        </span>
                      </td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w1.quantity}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w1.days}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.w1.speed, 3)}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w2.quantity}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w2.days}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.w2.speed, 3)}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w4.quantity}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.year, 3)}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.increase}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.potential}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.coverage, 0)}}</td>
                      <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.remaining, 0)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showMode == 'classes'">
          <div class="table-container">
            <table class="table is-fullwidth is-hoverable my-table">
              <thead>
                <th class="is-clickable" @click="changeClassSortOption('className')">
                  <span>Class</span>
                  <span class="icon" v-if="classSortOption.field == 'className'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w1Value')">
                  <span>Last 7 days</span>
                  <span class="icon" v-if="classSortOption.field == 'w1Value'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span><br/>
                  <span class="is-size-7 has-text-grey">Qt, Sales, COGS</span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w2Value')">
                  <span>Last 8~14 days</span>
                  <span class="icon" v-if="classSortOption.field == 'w2Value'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span><br/>
                  <span class="is-size-7 has-text-grey">Qt, Sales, COGS</span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w4Value')">
                  <span>Last 1 month</span>
                  <span class="icon" v-if="classSortOption.field == 'w4Value'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span><br/>
                  <span class="is-size-7 has-text-grey">Qt, Sales, COGS</span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w8Value')">
                  <span>Last 2 months</span>
                  <span class="icon" v-if="classSortOption.field == 'w8Value'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span><br/>
                  <span class="is-size-7 has-text-grey">Qt, Sales, COGS</span>
                </th>
                <!--
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w1Qt')">
                  <span>1 Week Qt</span>
                  <span class="icon" v-if="classSortOption.field == 'w1Qt'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w1Amount')">
                  <span>1 Week Amount</span>
                  <span class="icon" v-if="classSortOption.field == 'w1Amount'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w1Cogs')">
                  <span>1 Week COGS</span>
                  <span class="icon" v-if="classSortOption.field == 'w1Cogs'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w2Qt')">
                  <span>2 Week Qt</span>
                  <span class="icon" v-if="classSortOption.field == 'w2Qt'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w2Amount')">
                  <span>2 Week Amount</span>
                  <span class="icon" v-if="classSortOption.field == 'w2Amount'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w2Cogs')">
                  <span>2 Week COGS</span>
                  <span class="icon" v-if="classSortOption.field == 'w2Cogs'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w4Qt')">
                  <span>1 Month Qt</span>
                  <span class="icon" v-if="classSortOption.field == 'w4Qt'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w4Amount')">
                  <span>1 Month Amount</span>
                  <span class="icon" v-if="classSortOption.field == 'w4Amount'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable has-text-right" @click="changeClassSortOption('w4Cogs')">
                  <span>1 Month COGS</span>
                  <span class="icon" v-if="classSortOption.field == 'w4Cogs'">
                    <i class="fas" :class="{'fa-sort-up': classSortOption.asc, 'fa-sort-down': !classSortOption.asc}"></i>
                  </span>
                </th>
                -->
              </thead>
              <tbody>
                <tr v-for="(c, i) in showingClasses" :key="'classes-' + i">
                  <td>{{ c.className }}</td>
                  <td class="has-text-right">
                    <span>{{ c.w1 }}</span><br/>
                    <span class="is-size-7 has-text-grey">{{ c.w1Qt }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w1Amount, 0) }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w1Cogs, 0) }}</span>
                  </td>
                  <td class="has-text-right">
                    <span>{{ c.w2 }}</span><br/>
                    <span class="is-size-7 has-text-grey">{{ c.w2Qt }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w2Amount, 0) }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w2Cogs, 0) }}</span>
                  </td>
                  <td class="has-text-right">
                    <span>{{ c.w4 }}</span><br/>
                    <span class="is-size-7 has-text-grey">{{ c.w4Qt }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w4Amount, 0) }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w4Cogs, 0) }}</span>
                  </td>
                  <td class="has-text-right">
                    <span>{{ c.w8 }}</span><br/>
                    <span class="is-size-7 has-text-grey">{{ c.w8Qt }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w8Amount, 0) }},&nbsp;</span>
                    <span class="is-size-7 has-text-grey">{{ roundTo(c.w8Cogs, 0) }}</span>
                  </td>
                  <!--
                  <td class="has-text-right">{{ roundTo(c.w1Amount, 0) }}</td>
                  <td class="has-text-right">{{ roundTo(c.w1Cogs, 0) }}</td>
                  <td class="has-text-right">{{ c.w2Qt }}</td>
                  <td class="has-text-right">{{ roundTo(c.w2Amount, 0) }}</td>
                  <td class="has-text-right">{{ roundTo(c.w2Cogs, 0) }}</td>
                  <td class="has-text-right">{{ c.w4Qt }}</td>
                  <td class="has-text-right">{{ roundTo(c.w4Amount, 0) }}</td>
                  <td class="has-text-right">{{ roundTo(c.w4Cogs, 0) }}</td>
                  -->
                </tr>
              </tbody>
              <!--<tfoot>
                <th></th>
                <th class="has-text-right">{{ classTotals.w1Qt }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w1Amount, 0) }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w1Cogs, 0) }}</th>
                <th class="has-text-right">{{ classTotals.w2Qt }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w2Amount, 0) }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w2Cogs, 0) }}</th>
                <th class="has-text-right">{{ classTotals.w4Qt }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w4Amount, 0) }}</th>
                <th class="has-text-right">{{ roundTo(classTotals.w4Cogs, 0) }}</th>
              </tfoot>-->
            </table>
          </div>
        </div>

      </div>
      
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import { Fragment } from 'vue-fragment'

function getFieldValue (obj, path) {
  var ss = path.split('.')
  var value = obj[ss[0]]
  var i = 1
  while (i < ss.length && value) {
    value = value[ss[i]]
    i += 1
  }
  return value
}

function formatPercentage (value) {
  if (!value) {
    return ''
  }
  return roundTo(value*100, 0) + '%'
}

function roundTo (value, decimals) {
  if (decimals == 0) {
    return Math.round(value)
  }
  var tens = Math.pow(10, decimals)
  return Math.round((value + Number.EPSILON) * tens) / tens
}

export default {
  name: 'SalesMonitor',
  components: {
    Fragment
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      filter: ['All'],
      products: [],
      search: '',
      openedMap: {},
      sortOption: { field: 'itemSku', asc: true },
      country: 'US',
      showMode: 'items',
      showHidden: false,
      dates: [],
      selectedDate: 'Now',
      classSortOption: { field: 'className', asc: true },
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    countryPrefix () {
      return this.country.toLowerCase() + 'Sales'
    },
    classes () {
      var classes = {}
      var prefix = this.country.toLowerCase() + 'Sales'
      for (var p of this.products) {
        if (!p.className.trim() || p.className.includes('Consignment') || p.className.includes('FAUCET') || p.classId == '8' || p.className.trim() == 'REPLACEMENT' || p.classId == '33' || p.className.trim() == 'OVERFLOW' || p.className.trim() == 'Pallet' || p.className.trim() == 'USAM : TRAMPOLINE' || p.className.trim() == 'VANITY : MIRROR') {
          continue
        }
        if (!classes[p.classId]) {
          classes[p.classId] = {classId: p.classId, className: p.className, w1Qt: 0, w1Amount: 0, w1Cogs: 0, w1Value: 0, w2Qt: 0, w2Amount: 0, w2Cogs: 0, w2Value: 0, w4Qt: 0, w4Amount: 0, w4Cogs: 0, w4Value: 0, w8Qt: 0, w8Amount: 0, w8Cogs: 0, w8Value: 0}
        }
        classes[p.classId].w1Qt += p[prefix]['1w']['all']['quantity']
        classes[p.classId].w1Amount += p[prefix]['1w']['all']['amount']
        classes[p.classId].w1Cogs += p[prefix]['1w']['all']['landedCost'] || 0
        classes[p.classId].w2Qt += p[prefix]['2w']['all']['quantity']
        classes[p.classId].w2Amount += p[prefix]['2w']['all']['amount']
        classes[p.classId].w2Cogs += p[prefix]['2w']['all']['landedCost'] || 0
        classes[p.classId].w4Qt += p[prefix]['4w']['all']['quantity']
        classes[p.classId].w4Amount += p[prefix]['4w']['all']['amount']
        classes[p.classId].w4Cogs += p[prefix]['4w']['all']['landedCost'] || 0
        if (p[prefix]['8w']) {
          classes[p.classId].w8Qt += p[prefix]['8w']['all']['quantity']
          classes[p.classId].w8Amount += p[prefix]['8w']['all']['amount']
          classes[p.classId].w8Cogs += p[prefix]['8w']['all']['landedCost'] || 0
        }
      }

      for (var key in classes) {
        classes[key].w2Qt -= classes[key].w1Qt
        classes[key].w2Amount -= classes[key].w1Amount
        classes[key].w2Cogs -= classes[key].w1Cogs

        classes[key].w1Value = classes[key].w1Amount ? (classes[key].w1Cogs / classes[key].w1Amount) : 0
        classes[key].w2Value = classes[key].w2Amount ? (classes[key].w2Cogs / classes[key].w2Amount) : 0
        classes[key].w4Value = classes[key].w4Amount ? (classes[key].w4Cogs / classes[key].w4Amount) : 0
        classes[key].w8Value = classes[key].w8Amount ? (classes[key].w8Cogs / classes[key].w8Amount) : 0
        classes[key].w1 = formatPercentage(classes[key].w1Value)
        classes[key].w2 = formatPercentage(classes[key].w2Value)
        classes[key].w4 = formatPercentage(classes[key].w4Value)
        classes[key].w8 = formatPercentage(classes[key].w8Value)
      }
      
      return Object.values(classes)
    },
    showingClasses () {
      var vm = this
      var sort = vm.classSortOption
      var sorted = this.classes.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (!va || !vb) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }

        if (sort.field == 'className') {
          return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
        }
        return sort.asc ? va - vb : vb - va
      })
      return sorted
    },
    classTotals () {
      var totals = {w1Qt: 0, w1Amount: 0, w1Cogs: 0, w2Qt: 0, w2Amount: 0, w2Cogs: 0, w4Qt: 0, w4Amount: 0, w4Cogs: 0}
      for (var c of this.classes) {
        totals.w1Qt += c.w1Qt
        totals.w1Amount += c.w1Amount
        totals.w1Cogs += c.w1Cogs
        totals.w2Qt += c.w2Qt
        totals.w2Amount += c.w2Amount
        totals.w2Cogs += c.w2Cogs
        totals.w4Qt += c.w4Qt
        totals.w4Amount += c.w4Amount
        totals.w4Cogs += c.w4Cogs
      }
      return totals
    },
    showingProducts () {
      var vm = this
      var filtered = this.products.filter(p => {
        if (vm.filter.includes('All')) {
          return true
        }
        return vm.filter.includes(p.className)
      }).filter(p => {
        if (!vm.showHidden && p.hidden) {
          return false
        }
        var search = vm.search.toLowerCase()
        return p.itemId.toLowerCase().includes(search)
          || p.itemSku.toLowerCase().includes(search)
          || p.className.toLowerCase().includes(search)
      })

      var sort = vm.sortOption
      var sorted = filtered.sort((a, b) => {
        var va = getFieldValue(a, sort.field)
        var vb = getFieldValue(b, sort.field)
        if (!va || !vb) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        var prefix = vm.country.toLowerCase() + 'Sales.'
        if (sort.field == prefix + 'inventory.all' || sort.field == prefix + '1w.all.quantity' || sort.field == prefix + '1w.all.days' || sort.field == prefix + '1w.all.speed'
            || sort.field == prefix + '2w.all.quantity' || sort.field == prefix + '2w.all.days' || sort.field == prefix + '2w.all.speed' || sort.field == prefix + '4w.all.quantity'
            || sort.field == prefix + 'yearMax.all' || sort.field == prefix + 'speedIncrease.all'  || sort.field == prefix + 'potential.all' || sort.field == prefix + 'coverage.all'
            || sort.field == prefix + 'remaining.all') {
          if (!va || va == 'N/A' || va == '') {
            va = 0
          } else {
            va = parseFloat(va)
          }
          if (!vb || vb == 'N/A' || vb == '') {
            vb = 0
          } else {
            vb = parseFloat(vb)
          }
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sorted
    },
    showingItems () {
      var items = []
      this.showingProducts.forEach(p => {
        var mainItem = this.makeItem(p, 'all')
        items.push(mainItem)
        if (this.openedMap[p.itemId]) {
          ['hd', 'wf', 'lowes'].forEach(platform => {
            var pItem = this.makeItem(p, platform)
            items.push(pItem)
          })
        }
      })
      return items
    },
    classOptions () {
      var classNames = new Set()
      this.products.forEach(p => {
        if (this.showHidden || !p.hidden) {
          classNames.add(p.className)
        }
      })
      var classOptions = [...classNames]
      classOptions.sort((a, b) => a.localeCompare(b))
      classOptions.unshift('All')
      return classOptions
    },
  },
  watch: {
    selectedDate: function (val) {
      if (val == 'Now') {
        this.getProducts()
      } else {
        this.getProductsForDate(val)
      }
    },
    checkAll: function (val) {
      for (var p of this.showingProducts) {
        this.checkboxes[p.id] = val
      }
    },
  },
  methods: {
    makeItem (p, platform) {
      var ss = p.className.split(':')
      var className = platform == 'all' ? ss[ss.length-1].trim() : ''
      var platforms = {'hd': 'Home Depot', 'wf': 'Wayfair', 'lowes': 'Lowes'}
      ss = p.itemSku.split(':')
      var sku = ss[ss.length-1].trim()
      var name = platform == 'all' ? sku : platforms[platform]
      var itemId = platform == 'all' ? p.itemId : ''
      var prefix = this.country.toLowerCase() + 'Sales'
      var landedCost = platform == 'all' ? p[prefix]['landedCost'].map(c => this.roundTo(c, 0)).join(', ') : ''
      var item = {
        id: p.id,
        hidden: p.hidden,
        classId: p.classId,
        className: className,
        name: name,
        itemId: itemId,
        inventory: p[prefix]['inventory'][platform],
        landedCost: landedCost,
        w1: p[prefix]['1w'][platform],
        w2: p[prefix]['2w'][platform],
        w4: p[prefix]['4w'][platform],
        year: p[prefix]['yearMax'][platform],
        increase: p[prefix]['speedIncrease'][platform],
        potential: p[prefix]['potential'][platform],
        coverage: p[prefix]['coverage'][platform],
        remaining: p[prefix]['remaining'][platform],
      }
      if (p[prefix]['8w']) {
        item.w8 = p[prefix]['8w'][platform]
      }
      return item
    },
    getProducts () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-sale-summaries-now/').then(resp => {
        this.products = resp.body
        var openedMap = {}
        for (var p of this.products) {
          openedMap[p.itemId] = false
        }
        this.openedMap = openedMap
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    getProductsForDate (date) {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-sale-summaries-for-date/' + date).then(resp => {
        this.products = resp.body
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    getDates () {
      this.$http.get(this.server + '/myapp/get-sale-summary-dates/').then(resp => {
        var dates = resp.body
        dates.unshift('Now')
        this.dates = dates
      }, err => {
        console.log(err)
      })
    },
    toggleOpened (itemId) {
      this.openedMap[itemId] = !this.openedMap[itemId]
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : false
      }
    },
    roundTo (value, decimals) {
      if (typeof(value) == 'string') {
        return value
      }
      if (!value) {
        return 0
      }
      if (decimals == 0) {
        return Math.round(value)
      }
      var tens = Math.pow(10, decimals)
      return Math.round((value + Number.EPSILON) * tens) / tens
    },
    toggleHidden (id) {
      var message = {summaryId: id}
      this.$http.post(this.server + '/myapp/toggle-summary-hidden/', message).then(resp => {
        this.products.forEach(p => {
          if (p.id == id) {
            p.hidden = !p.hidden
          }
        })
      })
    },
    changeClassSortOption (field) {
      this.classSortOption = {
        field: field,
        asc: field == this.classSortOption.field ? !this.classSortOption.asc : false
      }
    },
  },
  mounted () {
    this.getProducts()
    this.getDates()
  },
}
</script>

<style scoped>
.hover-target {
  display: none; /* Initially hides the target element */
}

.hover-trigger:hover .hover-target {
  display: block; /* Shows the target element when the parent is hovered */
}

.my-title {
  display: inline;
}

.table-container {
  max-height: calc(100vh - 80px);
  overflow: auto;

  table {
    text-align: left;
    position: relative;
  }

  th {
    background: white;
    position: sticky;
    top: 0;
  }
}
</style>
